import { Grid, colors } from '@material-ui/core';

import PropTypes from 'prop-types';

import { SectionHeader, IconAlternate } from '@/src/components/molecules';
import { CardBase, DescriptionListIcon } from '@/src/components/organisms';

import SectionDynamic from './SectionDynamic';

export default function Features(props) {
  const { className, section, title, subtitle, features = [], refElem, ...rest } = props;

  return (
    <SectionDynamic type={section}>
      <div className={className} ref={refElem} {...rest}>
        {(title || subtitle) && <SectionHeader title={title} subtitle={subtitle} fadeUp />}
        {features.length > 0 && (
          <Grid container spacing={2}>
            {features.map(feature => (
              <Grid
                key={feature.title || feature.subtitle}
                item
                container
                alignItems="center"
                direction="column"
                xs={6}
                md={3}
                data-aos="fade-up">
                <CardBase
                  liftUp
                  variant="outlined"
                  style={{ borderTop: `5px solid ${colors[feature.color || 'grey'][500]}` }}>
                  <DescriptionListIcon
                    icon={
                      <IconAlternate
                        fontIconClass={feature.icon}
                        color={colors[feature.color || 'grey']}
                        shape="circle"
                        size="small"
                      />
                    }
                    title={feature.title}
                    subtitle={feature.subtitle}
                  />
                </CardBase>
              </Grid>
            ))}
          </Grid>
        )}
      </div>
    </SectionDynamic>
  );
}

Features.propTypes = {
  className: PropTypes.string,
  section: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  features: PropTypes.array.isRequired,
  refElem: PropTypes.any,
};
